import { 
  createContext,
  Dispatch,
  ReactNode, 
  SetStateAction, 
  useContext,
  useEffect,
  useState
} from 'react'
import { 
  createTheme,
  CssBaseline, 
  ThemeProvider as TP 
} from '@mui/material'
import { Theme as ThemeType } from '@emotion/react'

import { useAuth } from './auth'

interface ThemeProviderProps {
  children: ReactNode; 
  theme?: ThemeType ;
}

interface ThemeContext {
  mode: 'light' | 'dark';
  setMode: Dispatch<SetStateAction<"light" | "dark">>;
}

export interface Styles {
  // EmbosserCard
  embosserCard: any;
  embosserCardMedia: any;
  embosserCardContentContainer: any;
  embosserCardButtonOpen: any;
  embosserCardButtonDisconnect: any;
  modalLeftPanel: any;
  modalEmbosserImageCard: any;
  modalEmbosserImageCardMedia: any;
  modalButtonOpenBrailleApp: any;
  modalRightPanel: any;
  modalRightPanelLarge: any;
  modalRightPanelLargeScrollMask: any;
  modalRightPanelLargeLeftColumn: any;
  modalRightPanelLargeRightColumn: any;
  propertyAreaContainerOpen: any;
  propertyAreaContainerClosed: any;
  propertyAreaContainerHeader: any;
  propertyAreaTopMargin: any;
  propertyAreaBottomMargin: any;
  propertyAreaFlexGrow: any;
  propertyAreaMarginHorizontal: any;
  propertyAreaMarginLeft: any;
  propertyAreaPaddingInline: any;
  propertyAreaPaddingBottom: any;
  propertyAreaMarginBottom: any;
  leftPanelProperty: any;
  embosserRow: any;
  embosserRowButtonOpen: any;
  embosserRowButtonDisconnect: any;
  embosserRowPropertyArea: any;
  embosserRowPropertyAreaProperty: any;
  embosserRowPropertyAreaContent: any;
  // UserCard
  userCard: any;
  userCardButtonRemove: any;
  userCardButtonOpen: any;
  userRow: any;
  userRowButtonRemove: any;
  userRowButtonOpen: any;
  userRowPropertyArea: any;
  userRowPropertyAreaProperty: any;
  userRowPropertyAreaContent: any;
  // AccountCard
  accountCard: any;
  addPhoto: any;
  addPhotoOpaque: any;
  editPhotoIconHidden: any;
  editPhotoIconVisible: any;
  // EmbosserCard & UserCard
  propertyArea: any;
  propertyAreaProperty: any;
  propertyAreaContent: any;
  propertyAreaSmallTopMargin: any;
  modalContainer: any;
  modalScrollableContainer: any;
  modalButtonClose: any;
  // AccountCard & UserCard
  userPhotoContainer: any;
  userPhoto: any;
  // ShopCard
  shopItemRowButtonOpen: any;
  shopItemRowButtonCart: any;
  shopItemRowPropertyAreaPartNr: any;
  shopItemRowPropertyAreaDescription: any,
  shopItemRowPropertyAreaPrice: any,
  shopItemRowPropertyAreaDiscounted: any,
  shopItemRowPropertyAreaProperty: any;
  shopItemRowPropertyAreaContent: any;
  shopItemPhotoContainerRow: any;
  shopItemPhotoContainer: any;
  shopItemPhoto: any;
  shopItemButtonOpen: any;
  // shopCardButtonCart: any; // TBI when cart is implemented.
  // TranslationCard
  translationCard: any;
  translationCardOpenFileButton: any;
  translationCardItemsBox: any;
  translationCardItemsBoxListViewContainer: any;
  historyCard: any;
  historyCardItemsBox: any;
  historyCardItemsBoxItem: any;
  // Extra
  noOverflow: any;
}

export const styles: Styles = {
  // ================================
  //          EmbosserCard
  // ================================
  embosserCard: {
    width: "350px",
    padding: ".5em",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column"
  },
  embosserCardMedia: {
    objectFit: "contain",
    transform: "scale(1.1) translateY(10%)",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    border: ".5em solid #f6f6f6",
    justifyContent: "center",
    marginBottom: "1.5em",
    alignItems: "center",
    alignSelf: "center",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  embosserCardContentContainer: {
    margin: "0",
    padding: "0"
  },
  embosserCardButtonOpen: {
    width: "130px",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#85d201",
    margin: "0",
    borderRadius: "10px"
  },
  embosserCardButtonDisconnect: {
    width: "130px",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#f53636",
    margin: "0",
    borderRadius: "10px"
  },
  modalLeftPanel: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  modalEmbosserImageCard: {
    height: "auto",
    width: "95%",
    margin: ".5em 0em 0em 0em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  modalEmbosserImageCardMedia: {
    height: "100%",
    width: "100%",
    margin: "0",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6"
  },
  modalButtonOpenBrailleApp: {
    margin: "2em 0em 1em 0em",
    fontWeight: "bold",
    color: "#f6f6f6",
    borderRadius: "10px",
    backgroundColor: "#85d201"
  },
  modalRightPanel: {
    height: "auto",
    margin: ".5em .5em 1em 0em",
    padding: ".5em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&::-webkit-scrollbar': {
      width: ".3em"
    },
    '&::-webkit-scrollbar-track': {
      background: "transparent",
      boxShadow: "inset 0 0 10px #1c1c1c",
      borderRadius: "5px",
      borderLeft: "1px solid transparent",
      borderRight: "1px solid transparent"
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#444',
      outline: '1px solid #444',
      borderRadius: ".15em"
    }
  },
  modalRightPanelLarge: {
    height: "auto",
    margin: ".5em .5em 1em 0em",
    padding: "0",
    borderRadius: "10px",
    overflowY: "auto !important",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&::-webkit-scrollbar': {
      width: ".3em"
    },
    '&::-webkit-scrollbar-track': {
      background: "transparent",
      boxShadow: "inset 0 0 10px #1c1c1c",
      borderRadius: "5px",
      borderLeft: "1px solid transparent",
      borderRight: "1px solid transparent"
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#444',
      outline: '1px solid #444',
      borderRadius: ".15em"
    }
  },
  modalRightPanelLargeScrollMask: {
    width: "100%",
    height: "auto",
    display: "flex",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6"
  },
  modalRightPanelLargeLeftColumn: {
    width: "50%",
    height: "auto",
    padding: ".5em .25em .5em .5em"
  },
  modalRightPanelLargeRightColumn: {
    width: "50%",
    height: "auto",
    padding: ".5em .5em .5em .25em"
  },
  propertyAreaContainerOpen: {
    width: "100%",
    height: "auto",
    backgroundColor: "#f6f6f6",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px",
    padding: ".25em .25em .25em .25em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  propertyAreaContainerClosed: {
    width: "100%",
    height: "auto",
    backgroundColor: "#f6f6f6",
    alignItems: "center",
    borderRadius: "10px",
    padding: ".25em .25em .25em .25em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  propertyAreaContainerHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: ".5em"
  },
  propertyAreaTopMargin: {
    marginTop: ".5em !important"
  },
  propertyAreaBottomMargin: {
    marginBottom: ".5em !important"
  },
  propertyAreaFlexGrow: {
    flexGrow: "1"
  },
  propertyAreaMarginHorizontal: {
    width: "calc(100% - .5em) !important"
  },
  propertyAreaMarginLeft: {
    marginLeft: ".5em !important"
  },
  propertyAreaPaddingInline: {
    paddingInline: ".5em !important"
  },
  propertyAreaPaddingBottom: {
    paddingBottom: ".5em !important"
  },
  propertyAreaMarginBottom: {
    marginBottom: ".5em !important"
  },
  leftPanelProperty: {
    width: "95% !important",
    fontSize: ".9em"
  },
  embosserRow: {
    width: "auto",
    flexGrow: "1",
    height: "auto",
    padding: ".5em .5em .5em .5em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    display: "flex",
    marginInline: "1.5em",
    alignItems: "center",
    gap: ".5em"
  },
  embosserRowButtonOpen: {
    width: "100px",
    maxWidth: "130px",
    flexGrow: "1",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#85d201",
    margin: "0",
    borderRadius: "10px"
  },
  embosserRowButtonDisconnect: {
    width: "100px",
    maxWidth: "130px",
    flexGrow: "1",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#f53636",
    margin: "0",
    borderRadius: "10px"
  },
  embosserRowPropertyArea: {
    width: "50px",
    flexGrow: "1",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  embosserRowPropertyAreaProperty: {
    width: "auto",
    height: "auto",
    fontSize: ".9em",
    fontWeight: "bold",
    userSelect: "none",
    margin: "0",
    padding: "0",
    marginTop: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  embosserRowPropertyAreaContent: {
    fontSize: ".9em",
    fontWeight: "bold",
    color: "#252525",
    margin: "0",
    marginTop: ".25em",
    marginBottom: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-line"
  },

  // ================================
  //             UserCard
  // ================================
  userCard: {
    width: "350px",
    height: "auto",
    padding: "1em 1em 1em 1em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  userCardButtonRemove: {
    width: "100px",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#f53636",
    margin: "0",
    marginTop: "1.25em",
    borderRadius: "10px"
  },
  userCardButtonOpen: {
    width: "100px",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#85d201",
    margin: "0",
    marginTop: "1.25em",
    borderRadius: "10px"
  },
  userRow: {
    width: "auto",
    flexGrow: "1",
    height: "auto",
    padding: ".5em .5em .5em .5em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    display: "flex",
    marginInline: "1.5em",
    alignItems: "center",
    gap: ".5em"
  },
  userRowButtonRemove: {
    width: "50px",
    maxWidth: "100px",
    flexGrow: "1",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#f53636",
    margin: "0",
    borderRadius: "10px"
  },
  userRowButtonOpen: {
    width: "50px",
    maxWidth: "100px",
    flexGrow: "1",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#85d201",
    margin: "0",
    borderRadius: "10px"
  },
  // ================================
  //             ShopItemCard
  // ================================
  shopItemRowButtonOpen: {
    width: "50px",
    maxWidth: "100px",
    height: "27px",
    flexGrow: "1",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#85d201",
    margin: "0",
    borderRadius: "10px"
  },
  shopItemRowButtonCart: {
    width: "auto",
    maxWidth: "100px",
    height: "27px",
    flexGrow: "1",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#757575",
    margin: "0",
    borderRadius: "10px"
  },
  shopItemRowPropertyAreaPartNr: {
    width: "6%",
    minWidth: "65px",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  shopItemRowPropertyAreaDescription: {
    width: "40%",
    minWidth: "120px",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  shopItemRowPropertyAreaPrice: {
    width: "18%",
    minWidth: "80px",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  shopItemRowPropertyAreaDiscounted: {
    width: "18%",
    minWidth: "80px",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  shopItemRowPropertyAreaProperty: {
    width: "auto",
    height: "auto",
    fontSize: ".9em",
    fontWeight: "bold",
    userSelect: "none",
    margin: "0",
    padding: "0",
    marginTop: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  shopItemRowPropertyAreaContent: {
    fontSize: ".9em",
    fontWeight: "bold",
    color: "#252525",
    margin: "0",
    marginTop: ".25em",
    marginBottom: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-line"
  },
  shopItemButtonOpen: {
    width: "100px",
    fontWeight: "bold",
    color: "white",
    backgroundColor: "#85d201",
    margin: "0",
    marginTop: "1.25em",
    borderRadius: "10px"
  },
  // TBI when cart is implemented
  // shopCardButtonCart: {
  //   width: "35px",
  //   height: "35px",
  //   minWidth: 0,
  //   fontWeight: "bold",
  //   padding: "0",
  //   marginRight: "25px",
  //   color: "white",
  //   backgroundColor: "#757575",
  //   "&:hover": {
  //     backgroundColor: "#595959"  // MUI error red
  // },
  //   margin: "0",
  //   marginTop: "0.60em",
  //   borderRadius: "50%"
  // },
  shopItemPhotoContainerRow: {
    width: "65%",
    minWidth: "50px",
    maxWidth: "50px",
    aspectRatio: "1 / 1",
    borderRadius: "50%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    // border: ".5em solid #f6f6f6", // [LP] Do we want this?
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  shopItemPhotoContainer: {
    width: "65%",
    minWidth: "150px",
    maxWidth: "250px",
    aspectRatio: "1 / 1",
    borderRadius: "50%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    // border: ".5em solid #f6f6f6",  // [LP] Do we want this?
    justifyContent: "center",
    marginBottom: "1.5em",
    alignItems: "center",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  shopItemPhoto: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  // ================================
  //          AccountCard
  // ================================
  accountCard: {
    width: "min(95%, 550px)",
    height: "auto",
    padding: "1em 1em 1em 1em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  addPhoto: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    position: "absolute",
    margin: 0,
    left: 0,
    backgroundColor: "transparent",
    transition: "background-color .5s",
    cursor: "pointer"
  },
  addPhotoOpaque: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    position: "absolute",
    margin: 0,
    left: 0,
    backgroundColor: "transparent",
    transition: "background-color .5s",
    cursor: "pointer"
  },
  editPhotoIconHidden: {
    width: "30%",
    height: "30%",
    color: "transparent",
    transition: "color .5s"
  },
  editPhotoIconVisible: {
    width: "30%",
    height: "30%",
    transition: "color .5s"
  },

  // ================================
  //     EmbosserCard & UserCard
  // ================================
  propertyArea: {
    width: "100%",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    alignItems: "center",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  propertyAreaProperty: {
    width: "auto",
    height: "auto",
    fontSize: ".8em",
    color: "#666",
    fontWeight: "bold",
    userSelect: "none",
    margin: "0",
    padding: "0",
    marginTop: ".25em"
  },
  propertyAreaContent: {
    fontSize: ".9em",
    fontWeight: "bold",
    margin: "0",
    marginTop: ".25em",
    marginBottom: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-line"
  },
  propertyAreaSmallTopMargin: {
    marginTop: ".5em"
  },
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "85vw",
    height: "85dvh",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    display: "flex",
    boxShadow: "0px 0px 15px 5px rgba(0, 0, 0, 0.2)",
    padding: "1.5em 0em 1.5em 1.5em"
  },
  modalScrollableContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    borderRadius: "10px",
    overflowX: "hidden",
    margin: ".75em .5em 0em 0em",
    '&::-webkit-scrollbar': {
      width: ".3em"
    },
    '&::-webkit-scrollbar-track': {
      background: "transparent",
      boxShadow: "inset 0 0 10px #1c1c1c",
      borderRadius: "5px",
      borderLeft: "1px solid transparent",
      borderRight: "1px solid transparent"
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#444',
      outline: '1px solid #444',
      borderRadius: ".15em"
    }
  },
  modalButtonClose: {
    position: "absolute",
    height: "1em",
    width: "1em",
    right: ".25em",
    top: ".25em"
  },
  // ================================
  //     AccountCard & UserCard
  // ================================
  userPhotoContainer: {
    width: "65%",
    minWidth: "150px",
    maxWidth: "250px",
    aspectRatio: "1 / 1",
    borderRadius: "50%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    border: ".5em solid #f6f6f6",
    justifyContent: "center",
    marginBottom: "1.5em",
    alignItems: "center",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  userPhoto: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  userRowPropertyArea: {
    width: "50px",
    flexGrow: "1",
    height: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "10px",
    paddingLeft: "1.125em",
    paddingRight: ".5em",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    '&:before': {
      content: "''",
      position: "absolute",
      width: ".25em",
      height: "calc(100% - .8em)",
      borderRadius: "1em",
      top: ".4em",
      left: ".5em",
      backgroundColor: "#85d201",
      marginRight: ".25em"
    }
  },
  userRowPropertyAreaProperty: {
    width: "auto",
    height: "auto",
    fontSize: ".9em",
    fontWeight: "bold",
    userSelect: "none",
    margin: "0",
    padding: "0",
    marginTop: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  userRowPropertyAreaContent: {
    fontSize: ".9em",
    fontWeight: "bold",
    color: "#252525",
    margin: "0",
    marginTop: ".25em",
    marginBottom: ".25em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-line"
  },
  // ================================
  //         TranslationCard
  // ================================
  translationCard: {
    padding: "1em 1em .25em 1em",
    borderRadius: "10px",
    height: "fit-content",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column"
  },
  translationCardOpenFileButton: {
    width: "100%",
    borderRadius: "10px",
    marginBottom: "1em",
    fontSize: "1.25em",
    fontWeight: "bold",
    padding: "1.5em",
    color: "#656565",
    boxShadow: "0px 0px transparent",
    backgroundColor: "#ddd",
    "&:hover": {
      backgroundColor: "#eee"
    }
  },
  translationCardItemsBox: {
    display: "flex",
    flexDirection: "column",
    padding: "1em",
    width: "100%",
    backgroundColor: "#f6f6f6",
    position: "relative",
    borderRadius: "10px",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  translationCardItemsBoxListViewContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: ".5em",
    padding: "1em",
    overflow: "auto",
    height: "15.1em",
    width: "100%",
    backgroundColor: "#f6f6f6",
    position: "relative",
    borderRadius: "10px",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  historyCard: {
    padding: "1em 1em 1em 1em",
    borderRadius: "10px",
    backgroundColor: "#f6f6f6",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)",
    display: "flex",
    flexDirection: "column"
  },
  historyCardItemsBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: ".5em",
    width: "100%",
    height: "100%",
    overflowY: "auto",
    backgroundColor: "#f6f6f6",
    position: "relative",
    borderRadius: "10px",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },
  historyCardItemsBoxItem: {
    padding: ".5em",
    width: "100%",
    height: "auto",
    backgroundColor: "#f6f6f6",
    borderRadius: "10px",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.2)"
  },

  // ================================
  //              Extra
  // ================================
  noOverflow: {
    overflow: "hidden !important",
    textOverflow: "ellipsis !important"
  }
}

export const stylesDark: Styles = {
  ...styles,

  // ================================
  //          EmbosserCard
  // ================================
  embosserCard: {
    ...styles.embosserCard,
    backgroundColor: "#191919",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)",
  },
  embosserCardMedia: {
    ...styles.embosserCardMedia,
    border: ".5em solid #252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  modalEmbosserImageCard: {
    ...styles.modalEmbosserImageCard,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  modalEmbosserImageCardMedia: {
    backgroundColor: "#252525",
  },
  modalButtonOpenBrailleApp: {
    ...styles.modalButtonOpenBrailleApp,
    color: "#252525",
    backgroundColor: "#85d201"
  },
  modalRightPanel: {
    ...styles.modalRightPanel,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  modalRightPanelLarge: {
    ...styles.modalRightPanelLarge,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  modalRightPanelLargeScrollMask: {
    ...styles.modalRightPanelLargeScrollMask,
    backgroundColor: "#252525"
  },
  propertyAreaContainerOpen: {
    ...styles.propertyAreaContainerOpen,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  propertyAreaContainerClosed: {
    ...styles.propertyAreaContainerClosed,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  embosserRow: {
    ...styles.embosserRow,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  embosserRowPropertyArea: {
    ...styles.embosserRowPropertyArea,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  embosserRowPropertyAreaContent: {
    ...styles.embosserRowPropertyAreaContent,
    color: "white"
  },

  // ================================
  //             UserCard
  // ================================
  userCard: {
    ...styles.userCard,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  userRow: {
    ...styles.userRow,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  userRowPropertyArea: {
    ...styles.userRowPropertyArea,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  userRowPropertyAreaContent: {
    ...styles.userRowPropertyAreaContent,
    color: "white"
  },

  // ================================
  //         ShopItemCard
  // ================================
  shopItemRowPropertyAreaPartNr: {
  ...styles.shopItemRowPropertyAreaPartNr,
  backgroundColor: "#252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  shopItemRowPropertyAreaDescription: {
  ...styles.shopItemRowPropertyAreaDescription,
  backgroundColor: "#252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  shopItemRowPropertyAreaPrice: {
  ...styles.shopItemRowPropertyAreaPrice,
  backgroundColor: "#252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  shopItemRowPropertyAreaDiscounted: {
  ...styles.shopItemRowPropertyAreaDiscounted,
  backgroundColor: "#252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  shopItemRowPropertyAreaProperty: {
  ...styles.shopItemRowPropertyAreaProperty,
  backgroundColor: "#252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  shopItemRowPropertyAreaContent: {
  ...styles.shopItemRowPropertyAreaContent,
  backgroundColor: "#252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  shopItemPhotoContainer: {
  ...styles.userPhotoContainer,
  border: ".5em solid #252525",
  boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  // TBI after cart is implemented
  // shopCardButtonCart: {
  //   ...styles.shopCardButtonCart,
  //   backgroundColor: "#fff",
  //   "&:hover": {
  //     backgroundColor: "#fff",  // MUI error red
  //     color: "#4a4a4a"
  //   },
  //   color: "#121212",
  // },

  // ================================
  //          AccountCard
  // ================================
  accountCard: {
    ...styles.accountCard,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)",
  },

  // ================================
  //     EmbosserCard & UserCard
  // ================================
  propertyArea: {
    ...styles.propertyArea,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  propertyAreaContent: {
    ...styles.propertyAreaContent,
    color: "white"
  },
  modalContainer: {
    ...styles.modalContainer,
    backgroundColor: "#252525",
    boxShadow: "0px 0px 15px 5px rgba(0, 0, 0, 0.5)"
  },

  // ================================
  //     AccountCard & UserCard
  // ================================
  userPhotoContainer: {
    ...styles.userPhotoContainer,
    border: ".5em solid #252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },

  // ================================
  //         TranslationCard
  // ================================
  translationCard: {
    ...styles.translationCard,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  translationCardOpenFileButton: {
    ...styles.translationCardOpenFileButton,
    color: "#fff",
    backgroundColor: "#353535",
    "&:hover": {
      backgroundColor: "#555"
    }
  },
  translationCardItemsBox: {
    ...styles.translationCardItemsBox,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  translationCardItemsBoxListViewContainer: {
    ...styles.translationCardItemsBoxListViewContainer,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  historyCard: {
    ...styles.historyCard,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  historyCardItemsBox: {
    ...styles.historyCardItemsBox,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  },
  historyCardItemsBoxItem: {
    ...styles.historyCardItemsBoxItem,
    backgroundColor: "#252525",
    boxShadow: "0px 3px 12px -1px rgba(0, 0, 0, 0.5)"
  }
}

const Theme = createContext({} as ThemeContext)

export default function ThemeProvider({ 
  children, 
  theme 
}: ThemeProviderProps) {
  const { user } = useAuth()
  const [mode, setMode] = useState<'light' | 'dark'>('light')

  const defaultTheme = {
    mode,
    transitions: {
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
      },
      easing: {
        easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
        easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
        sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
      },
    },
  }

  theme = createTheme({
    ...defaultTheme,
    palette: {
      ...defaultTheme,
      background: mode === 'light' ? { default: '#f6f6f6' }  : { default: '#333', paper: '#252525' },
      primary: mode === 'light' ? { main: '#85d201' } : { main: '#85d201' },
      secondary: mode === 'light' ? { main: '#252525' } : { main: '#85d201' },
    }
  })

  useEffect(() => {
    if (user && user.theme) setMode(user.theme)
  // eslint-disable-next-line
  }, [user])

  return (
    <Theme.Provider
      value={{
        mode,
        setMode
      }}
    >
      <TP theme={theme}>
        <CssBaseline />
        {children}
      </TP>
    </Theme.Provider>
  )
}

export const useTheme = () => useContext(Theme)